const search = {
  zh: {
    search: "万能搜索",
    skill: "搜索技巧",
    searchEngines: "搜索",
    image: "图片",
    translate: "词典",
    social: "社交",
    moviesAndTV: "影视",
    music: "音乐",
    download: "资源",
    app: "软件",
    shop: "购物",
    book: "书籍",
    scholar: "学术"
  },
  en: {
    search: "Search",
    skill: "Search Skill",
    searchEngines: "Search",
    image: "Image",
    translate: "Translate",
    social: "Social",
    moviesAndTV: "Movies & TV",
    music: "Music",
    download: "Download",
    app: "App",
    shop: "Shop",
    book: "Book",
    scholar: "Scholar"
  }
}

export default search;


// WEBPACK FOOTER //
// ./src/language/module/search.js